import { Dimensions, Platform } from 'react-native';
/**
 * 因为这里getDeviceInfoSync可以支持web端，所以没直接用@kds/react-native-iphone-x-helper
 */
import getDeviceInfoSync from '../getDeviceInfoSync';
export default function isIphone() {
    if (Platform.OS === 'ios') {
        return true;
    }
    if (Platform.OS === 'web') {
        return /iP(hone|ad)/.test(window.navigator.userAgent);
    }
    return false;
}
const checkDimension = (size) => {
    const window = Dimensions.get('window');
    const windowRes = window.width === size || window.height === size;
    const screen = Dimensions.get('screen');
    const screenRes = screen.width === size || screen.height === size;
    return windowRes || screenRes;
};
const checkDimensions = (portraitWidth, portraitHeight) => {
    const window = Dimensions.get('window');
    const windowRes = (window.height === portraitHeight && window.width === portraitWidth) ||
        (window.width === portraitHeight && window.height === portraitWidth);
    const screen = Dimensions.get('screen');
    const screenRes = (screen.height === portraitHeight && screen.width === portraitWidth) ||
        (screen.width === portraitHeight && screen.height === portraitWidth);
    return windowRes || screenRes;
};
export function isIphoneX() {
    return (isIphone() &&
        // @ts-ignore
        !Platform.isPad &&
        // @ts-ignore
        !Platform.isTVOS &&
        (checkDimension(780) ||
            checkDimension(812) ||
            checkDimension(844) ||
            checkDimension(852) ||
            checkDimension(874) ||
            checkDimension(896) ||
            checkDimension(926) ||
            checkDimension(932) ||
            checkDimension(956)));
}
// 12, 12 Pro, 13, 13 Pro and 12 Pro Max, 13 Pro Max
const _isStatusBarHeight47 = () => {
    return checkDimensions(390, 844) || checkDimensions(428, 926);
};
// 11, xr
const _isStatusBarHeight48 = () => {
    // 暂时无法用宽高来判断 11 和 xr，因为 11 和 11 pro max 也是这个尺寸
    if (!checkDimensions(414, 896)) {
        return false;
    }
    // const ret = NativeModules?.KRNBasic?.getDeviceInfoSync();
    const ret = getDeviceInfoSync();
    if (ret) {
        const model = ret.model;
        if (model === 'iPhone12,1' || model === 'iPhone11,8') {
            return true;
        }
    }
    return false;
};
// 12 Mini, 13 Mini
const _isStatusBarHeight50 = () => {
    return checkDimensions(360, 780) || checkDimensions(375, 812);
};
// 14 Pro, 14 Pro Max
const _isStatusBarHeight59 = () => {
    return checkDimensions(393, 852) || checkDimensions(430, 932);
};
// 16 Pro, 16 Pro Max
const _isStatusBarHeight62 = () => {
    return checkDimensions(402, 874) || checkDimensions(440, 956);
};
export function _getIphoneStatusBarHeight() {
    if (isIphoneX()) {
        if (_isStatusBarHeight47()) {
            return 47;
        }
        if (_isStatusBarHeight48()) {
            return 48;
        }
        if (_isStatusBarHeight50()) {
            return 50;
        }
        if (_isStatusBarHeight59()) {
            return 59;
        }
        if (_isStatusBarHeight62()) {
            return 62;
        }
        return 44;
    }
    return 20;
}
//灵动岛
export function isDynamicIsland() {
    return (Platform.OS === 'ios' &&
        !Platform.isPad &&
        !Platform.isTVOS &&
        (_isStatusBarHeight59() || _isStatusBarHeight62()));
}
